module.exports = __webpack_public_path__ + "img/event2412_4.a7b2dbf0.png";